import { lazy, Suspense } from "react";

const AdminApp = lazy(() =>
  import("./components/AdminApp").then((module) => ({ default: module.AdminApp }))
);
const PublicFeed = lazy(() =>
  import("./components/PublicFeed").then((module) => ({ default: module.PublicFeed }))
);

export function App() {
  const isAdminHostname = window.location.hostname.toLowerCase() === "admin.leowishes.com";
  const isAdminPath = window.location.pathname.replace(/\/+$/, "").endsWith("/admin");

  return (
    <Suspense fallback={<div className="route-loading">Loading</div>}>
      {isAdminHostname || isAdminPath ? <AdminApp /> : <PublicFeed />}
    </Suspense>
  );
}
